export default "__VITE_ASSET__B2BUUz4B__"